import type { CSSObject } from '@emotion/react';
import { css, Global } from '@emotion/react';
import { useAppSelector } from '../grid/reduxStore/Store.ts';
import { selectTableRowStyles } from '../grid/reduxStore/tableRowDefaultStyleSlice.ts';
import { DEFAULT_TABLE_BACKGROUND_COLOR } from '../shared/documentColorDefaults';

const TableRowDefaultStylesLoader = () => {
  const tableRowDefaultStyle = useAppSelector(selectTableRowStyles);
  const tableRowCss = {
    ' :root {': {
      '--table-row-default-background-color': DEFAULT_TABLE_BACKGROUND_COLOR,
      ...tableRowDefaultStyle,
    },
  };
  return <Global styles={css(tableRowCss as unknown as CSSObject)} />;
};

export default TableRowDefaultStylesLoader;
